import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect } from "react";
import { useEncuestaCalidad } from "hooks/encuestas/encuestaCalidad";
import { ModalContentEncuesta } from "./components/ModalContentEncuesta";

export const ModalEncuesta = () => {
  const {
    user,
    datosEncuesta, 
    isEncuestaOpen,
    startGetEncuesta,
  } = useEncuestaCalidad();
  useEffect(() => {
    if (user && user?.session) {
      startGetEncuesta(6);
    } // eslint-disable-next-line
  }, [user]);
  return (
    <Dialog
      open={isEncuestaOpen}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      scroll="paper"
    >
      <DialogTitle>{datosEncuesta?.nombreEncuesta}</DialogTitle>
      <DialogContent>{<ModalContentEncuesta />}</DialogContent>
    </Dialog>
  );
};
